import {ShadowMessage} from "./Message";
import {APIEmbed} from "discord-api-types/v10";
import {GatewayEvent} from "./GatewayEvent";
import {ErrorCode} from "./ErrorCode";
import {PaletteMode} from "@mui/material";
import {Message} from "../../stores/MessageStore";

export enum ClientEvent {
    MESSAGE_CREATE = 'MESSAGE_CREATE',
    MESSAGE_UPDATE = "MESSAGE_UPDATE",
    MESSAGE_DELETE = "MESSAGE_DELETE",
    ROOM_SYNCED = "ROOM_SYNCED",
    MESSAGES_PURGED = "MESSAGES_PURGED",
}

export enum ClientType {
    TRIBO_APP = 'TRIBO_APP',
    SHADOW_APP = 'SHADOW_APP',
    SHADOW_CHATBOT = 'SHADOW_CHATBOT',
}

export interface APIUser {
    id: string
    username: string
    login_token: string
    room_id: string | null
    avatar: string | null
}

export interface SimpleMessage {
    author_id: string
    content: string | null
    embeds: object[] | null
    attachments: object[] | null
    author: {
        avatar: string | null
        username: string
        display_name: string | null
    }
}

export interface JoinData {
    clientId: string
    inviteToken?: string
}

//@todo fix this anonymous === public (switched around on server because this seems more logical)?
export enum RoomTypes {
    ANONYMOUS,
    PRIVATE,
    PUBLIC
}

export interface APIRoom {
    name: string
    id: string
    type: RoomTypes
    invited: string[]
    banned: string[]
    muted: string[]
    lastMessage?: SimpleMessage
}

export interface PartialTheme {
    components?: Record<string, any>;
    palette: {
        mode: PaletteMode,
        primary: {
            main: string
            light?: string
            dark?: string
            contrastText?: string
        },
        background: {
            default: string
            paper: string
        }
    }
}

export interface ShadowTheme {
    id: string
    creator_id: string
    name: string
    data: ThemeData
    creation_date: string
}

export interface ThemeData {
    name?: string
    theme: PartialTheme
    metadata: {
        name: string
        type?: string
        creator?: {
            id: string
            name: string
        },
        comment: string
    },
}

export interface ShadowPayload {
    error?: ShadowError;
    type: GatewayEvent
    data?: any
}

export interface ShadowError {
    errorCode: ErrorCode,
    message: string,
    data: any,
}

export interface Config {
    registrationsOpen: boolean
    tokenRequired: boolean
    appVersion: string
    apiVersion?: string
}

export interface AppData {
    messages: ShadowMessage[],
    roles: []
    users: APIUser[]
    user: APIUser
    rooms: APIRoom[]
    config: Config
    userConfig: object
    userCount: number
    roomCount: number
}

export interface RoomData {
    room: APIRoom
    messages: RestShadowMessage[]
    users: APIUser[]
}

export interface RoomSyncData {
    messages: Message[]
}

export interface BasicRoomData {
    room_id: string
}

export interface RestShadowMessage {
    id: string
    content: string
    room_id: string
    author_id: string
    room: APIRoom
    author?: APIUser
}

export interface FormattedPayload {
    content?: string;
    embeds?: APIEmbed[];
    message_reference?: string
}

export interface UserPatchPayload {
    username?: string
    avatar?: string  //       'avatar': 'data:image/png;base64,' + base64Image,
    email?: string
    password?: string
    global_name?: string,
    new_password?: string
}
